<alaris-dialog [closeAction]="close.bind(this)" [confirmAction]="confirm.bind(this)" [loading$]="usersService.loading$"
			   size="md">
	<h6 slot="header">{{ 'users_roles.users.userRemoving' | translate }}</h6>
	<div slot="content">
		<h3><strong>{{ data.user.Login }}</strong></h3>
	</div>
</alaris-dialog>
